module.exports = __webpack_public_path__ + "img/5css.7784b77b.png";